import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import StatementsPreferencesActionCreator from '../actions/StatementsPreferencesActionCreator';
import StatementsPreferencesParser from '../parsers/StatementsPreferencesParser';

const _statementPreferenceEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/preferences';

class StatementsPreferencesApiUtils {
  /*
   ** api call to get the preferences
   */
  static getPreferences() {
    const url = envConfig.apiBaseUrlPAAS + _statementPreferenceEndpoint;
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.setStatementPreferences,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        StatementsPreferencesActionCreator.handleStatementPreferenceSuccess(
          body,
          false
        );
      },
      () => {
        // StatementsPreferencesActionCreator.handleStatementPreferenceError(error);
      }
    );
  }

  static setStatementPreferenceCall(requestPacket) {
    const requestData =
      StatementsPreferencesParser.getRequestPacketForSetPreferences(
        requestPacket
      );
    const url = envConfig.apiBaseUrlPAAS + _statementPreferenceEndpoint;
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.setStatementPreferences,
        method: 'PUT',
        url,
        addAuthToken: true,
        requestData,
      },
      (body) => {
        StatementsPreferencesActionCreator.handleStatementPreferenceSuccess(
          body,
          true
        );
      },
      (error) => {
        StatementsPreferencesActionCreator.handleStatementPreferenceError(
          error
        );
      }
    );
  }
}

export default StatementsPreferencesApiUtils;
